import styled from 'styled-components';

const Flex = styled.div`
  display: flex;
  ${props => props.inline && 'display: inline-flex;'}
  ${props => props.column && 'flex-direction: column;'}
  ${props => props.reverse && 'flex-direction: row-reverse;'}
  ${props => props.wrap && 'flex-wrap: wrap;'}
  ${props =>
    props.justifyContent && `justify-content: ${props.justifyContent};`}
  ${props => props.alignItems && `align-items: ${props.alignItems};`}
`;

const FlexItem = styled.div`
  ${props => props.flex && `flex: ${props.flex};`}
  ${props => props.order && `order: ${props.order};`}
  ${props => props.alignSelf && `align-self: ${props.alignSelf};`}
`;

export { FlexItem };

export default Flex;
